<template>
  <div
    id="service"
    class="home-service"
  >
    <div class="service-left">
      <h2 class="service-title">
        <p>
          SERV<span>ICE</span>
        </p>
      </h2>
    </div>
    <div class="service-right">
      <swiper
        ref="mySwiper"
        class="swiper"
        :options="swiperOptions"
      >
        <swiper-slide>
          <div class="slide-bg">
            <picture>
              <source
                type="image/webp"
                :srcset="require('@/assets/images/items/ad.webp')"
              >
              <img
                :src="require('@/assets/images/items/ad.jpg')"
                alt
              >
            </picture>
          </div>
          <div class="service-detail d-flex justify-content-center justify-content-md-end align-items-center">
            <div class="glass-detail">
              <h3>
                廣告投放
              </h3>
              <div class="detail-english">
                Advertising
              </div>
              <div class="detail-desc">
                幫助遊戲伺服器主持人擴大其玩家基礎。平台可能提供多種廣告形式，如橫幅廣告、彈出視窗廣告、文字鏈接廣告等，並根據廣告主的需求進行定制化設置。
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slide-bg">
            <picture>
              <source
                type="image/webp"
                :srcset="require('@/assets/images/items/server.webp')"
              >
              <img
                :src="require('@/assets/images/items/server.jpg')"
                alt
              >
            </picture>
          </div>
          <div class="service-detail d-flex justify-content-center justify-content-md-end align-items-center">
            <div class="glass-detail">
              <h3>
                伺服器資訊
              </h3>
              <div class="detail-english">
                Server Information
              </div>
              <div class="detail-desc">
                提供有關私服遊戲伺服器的詳細資訊，玩家更容易找到合適的伺服器。提供遊戲伺服器的名稱、描述、版本資訊、玩家人數上限等相關資訊。
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slide-bg">
            <picture>
              <source
                type="image/webp"
                :srcset="require('@/assets/images/items/download.webp')"
              >
              <img
                :src="require('@/assets/images/items/download.jpg')"
                alt
              >
            </picture>
          </div>
          <div class="service-detail d-flex justify-content-center justify-content-md-end align-items-center">
            <div class="glass-detail">
              <h3>
                檔案下載
              </h3>
              <div class="detail-english">
                File Download
              </div>
              <div class="detail-desc">
                玩家可以下載遊戲客戶端、插件或其他相關資源。提供一個集中的資源庫，讓玩家能夠更輕鬆地獲取和安裝必需的檔案。
              </div>
            </div>
          </div>
        </swiper-slide>
        <!-- <div class="swiper-button-next" />
        <div class="swiper-button-prev" /> -->
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  directives: {
    // Ripple,
  },
  data() {
    return {
      swiperOptions: {
        loop: true,
        // effect: 'fade',
        // grabCursor: true,
        autoplay: true,
        parallax: true,
        centerSlides: true,
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          init() {
            const swiper = this
            const slideImg = document.querySelectorAll('.slide-bg')
            for (let i = 0; i < slideImg.length; i += 1) {
              slideImg[i].setAttribute('data-swiper-parallax', 0.75 * swiper.width)
              slideImg[i].setAttribute('data-swiper-parallax-opacity', 0.5)
            }
          },
        },
      },
    }
  },

  computed: {
  },

  methods: {
  },

  setup() {
  },
}
</script>
<style lang="scss" scoped>
.home-service{
  position: relative;
  width: 100%;
  min-height: 900px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 30vh 0 10vh;
  background-color: black;
}
.service-left {
  position: relative;
  width: 20%;
  .service-title {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    // transform: translateX(40%);
    writing-mode: vertical-lr;
    line-height: 1;
    font-size: clamp(1.5rem, 9vw, 13rem);
    -webkit-text-stroke-width: 0.8px;
    -webkit-text-stroke-color: #fff;
    color: rgba(255, 255, 255, 0);
    pointer-events: none;
    text-transform: uppercase;
    transform: translateX(70%);
    p {
      line-height: 1;
      letter-spacing: 0;
      transform: translateY(-15%);
    }
    span {
      color: #fff;
    }
  }
}
.service-right {
  width: 80%;
}
.swiper {
  height: 600px;
}
.swiper-slide {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.slide-bg {
  position: absolute;
  height: 100%;
  width: 100%;
  img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // min-width: 100%;
    width: 100%;
    height: 100%;
    object-fit: cover;
    // object-position: center center;
  }
}
.service-detail {
  width: 100%;
  height: 100%;
  padding: 0 3rem;
}
.glass-detail {
  width: 100%;
  max-width: 500px;
  min-height: 300px;
  z-index: 20;
  padding: 2rem;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(105, 105, 105, 0.15);
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  h3{
    font-size: 50px;
    font-weight: 900;
    color: #fff;
  }
  .detail-english {
    font-size: 20px;
    font-weight: 800;
    color: #fff900;
    letter-spacing: 1px;
    margin-bottom: 2rem;
  }
  .detail-desc {
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
}
@media screen and (max-width: 1200px) {
  .service-left {
    width: 10%;
    .service-title {
      font-size: 15vw;
    }
  }
  .service-right {
    width: 90%;
  }
}
@media screen and (max-width: 768px) {
  .service-detail {
    padding: 0 1rem;
  }
  .glass-detail {
    h3 {
      font-size: 35px;
    }
    .detail-desc {
      font-size: 15px;
    }
  }
}
@media screen and (max-width: 576px) {
  .service-left {
    width: 20%;
    .service-title {
      font-size: 24vw;
    }
  }
  .service-right {
    width: 80%;
  }
}
</style>
